export default "/build/images/029-2-300x300.png?f1360266b350ade62de7dcdbdee3b751";